// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: aliceblue;
}

#isochronePoiWrapper {
    opacity: 0;
}


.tabs-wrapper {
    display: flex;
    flex-direction: column;
    width: var(--tabs-wrapper-width);
    flex-wrap: wrap;
    position: absolute;
    top: 100px;
    left: 0;
}

.tab-and-slider-wrapper {
    /* border: 2px solid red; */
    position: relative;
    display: flex;
}

.tab {
    background-color: white;
    border: 1px solid black;
    padding: 15px;
    transition: background-color 200ms ease-in-out;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 60px;
    position: relative;
    cursor: pointer;
}

.slider-wrapper {
    color: white;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-evenly;
    width: 200px;
    text-align: center;
    border: 1px solid black;
    border-left: 0px;
    padding: 15px;
    left: calc(var(--tabs-wrapper-width) + 10px);
    background-color: rgba(0, 0, 0, 0.6);
}

.desc {
    pointer-events: none;
}

.slider {
    background-color: orange;
    width: 100%;
}

.tab:active {
    background-color: #85b5b2;
}

.tab-image {
    width: 60px;
    align-items: center;
    pointer-events: none;
    user-select: none;
}


.selected {
    background-color: #4682b4;
}

.selected>img {
    filter: invert(1);
}

.selected>.tab-label {
    color: white;
}

.hidden {
    display: none;
}

#isochronePoiWrapper>div {
    opacity: 1;
}

#collapsible-poi {
    display: none;
}

.collapsible-title {
    font-size: 12px;
    text-align: left;
    display: block;
    width: 70px;

    padding: 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;

    cursor: pointer;
    border: 1px solid black;
    border-bottom: 0px;
}

.economic-title {
    opacity: 0;
    font-size: 12px;
    text-align: left;
    display: block;
    width: 70px;
    margin-bottom: 30px;

    padding: 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;

    cursor: pointer;
    border: 1px solid black;
    border-bottom: 0px;
}

.collapsible-content {
    visibility: hidden;
}

.tab-label {
    width: 60px;
    text-align: center;
    pointer-events: none;
    justify-content: center;
    display: flex;
}

.tab-label>h1 {
    text-align: center;
    font-size: 14px;
    font-weight: normal;
    margin: 0px;
}

.slider-wrapper>.tab-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.large-select {
    height: 30px;
    width: 150px;
}

div.slider-wrapper fieldset {
    border: none;
    padding-bottom: 0px;
}

div.wrapper-flex-column {
    display: flex;
    flex-direction: row;
}

div.tab-item-column {
    display: flex;
    flex-direction: column;
}

.legend-wrapper {
    height: 220px;
    width: 93px;
    background-color: #00000099;
}

#poi-legend {
    display: flex;
    flex-direction: column;
    height: 90%;
    margin: 5px;
    border: 1px solid silver;
}

.legend-item {
    display: flex;
    align-items: center;
    flex-basis: 8.33%;
    align-content: center;
}

.legend-color {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/css/isochrone.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,OAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,8CAA8C;IAC9C,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,4CAA4C;IAC5C,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;;IAEX,aAAa;IACb,oCAAoC;IACpC,YAAY;;IAEZ,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,mBAAmB;;IAEnB,aAAa;IACb,oCAAoC;IACpC,YAAY;;IAEZ,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":["body {\n    background-color: aliceblue;\n}\n\n#isochronePoiWrapper {\n    opacity: 0;\n}\n\n\n.tabs-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: var(--tabs-wrapper-width);\n    flex-wrap: wrap;\n    position: absolute;\n    top: 100px;\n    left: 0;\n}\n\n.tab-and-slider-wrapper {\n    /* border: 2px solid red; */\n    position: relative;\n    display: flex;\n}\n\n.tab {\n    background-color: white;\n    border: 1px solid black;\n    padding: 15px;\n    transition: background-color 200ms ease-in-out;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: 60px;\n    position: relative;\n    cursor: pointer;\n}\n\n.slider-wrapper {\n    color: white;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    justify-content: space-evenly;\n    width: 200px;\n    text-align: center;\n    border: 1px solid black;\n    border-left: 0px;\n    padding: 15px;\n    left: calc(var(--tabs-wrapper-width) + 10px);\n    background-color: rgba(0, 0, 0, 0.6);\n}\n\n.desc {\n    pointer-events: none;\n}\n\n.slider {\n    background-color: orange;\n    width: 100%;\n}\n\n.tab:active {\n    background-color: #85b5b2;\n}\n\n.tab-image {\n    width: 60px;\n    align-items: center;\n    pointer-events: none;\n    user-select: none;\n}\n\n\n.selected {\n    background-color: #4682b4;\n}\n\n.selected>img {\n    filter: invert(1);\n}\n\n.selected>.tab-label {\n    color: white;\n}\n\n.hidden {\n    display: none;\n}\n\n#isochronePoiWrapper>div {\n    opacity: 1;\n}\n\n#collapsible-poi {\n    display: none;\n}\n\n.collapsible-title {\n    font-size: 12px;\n    text-align: left;\n    display: block;\n    width: 70px;\n\n    padding: 10px;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n\n    cursor: pointer;\n    border: 1px solid black;\n    border-bottom: 0px;\n}\n\n.economic-title {\n    opacity: 0;\n    font-size: 12px;\n    text-align: left;\n    display: block;\n    width: 70px;\n    margin-bottom: 30px;\n\n    padding: 10px;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n\n    cursor: pointer;\n    border: 1px solid black;\n    border-bottom: 0px;\n}\n\n.collapsible-content {\n    visibility: hidden;\n}\n\n.tab-label {\n    width: 60px;\n    text-align: center;\n    pointer-events: none;\n    justify-content: center;\n    display: flex;\n}\n\n.tab-label>h1 {\n    text-align: center;\n    font-size: 14px;\n    font-weight: normal;\n    margin: 0px;\n}\n\n.slider-wrapper>.tab-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.large-select {\n    height: 30px;\n    width: 150px;\n}\n\ndiv.slider-wrapper fieldset {\n    border: none;\n    padding-bottom: 0px;\n}\n\ndiv.wrapper-flex-column {\n    display: flex;\n    flex-direction: row;\n}\n\ndiv.tab-item-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.legend-wrapper {\n    height: 220px;\n    width: 93px;\n    background-color: #00000099;\n}\n\n#poi-legend {\n    display: flex;\n    flex-direction: column;\n    height: 90%;\n    margin: 5px;\n    border: 1px solid silver;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    flex-basis: 8.33%;\n    align-content: center;\n}\n\n.legend-color {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
